import { selectors } from 'data'
import { StateType } from 'data/types'

const get = (state: StateType) => state.payments.withdrawal

export const getData = (state: StateType) => get(state).data
export const isFetching = (state: StateType) => get(state).fetching
export const hasError = (state: StateType) => get(state).hasError

type WithdrawData = {
  fee: number
  gross: number
  max: number
  min: number
}
export const getWithdrawInfo = (state: StateType): Record<string, WithdrawData> | null => {
  const withdrawInfo = get(state)
  if (!withdrawInfo?.currency || !withdrawInfo?.data) return null

  const getMinorUnits = selectors.currencies.getMinorUnitsFactory(state)
  const minorUnits = getMinorUnits(withdrawInfo.currency)
  const data = withdrawInfo.data.withdrawal ?? {}
  return Object.keys(data).reduce((pms, pmID) => {
    const pmInfo = data[pmID]
    return {
      ...pms,
      [pmID]: {
        fee: parseFloat(pmInfo?.fee) / minorUnits,
        gross: parseFloat(pmInfo?.grossAmount) / minorUnits,
        max: parseFloat(pmInfo?.maxAmount) / minorUnits,
        min: parseFloat(pmInfo?.minAmount) / minorUnits
      }
    }
  }, {})
}
